export const STYLE_TAG_PREFIX = 'ac-style';
export const LINK_STYLE_TAG_NAME = 'ac-theme';
